
import { motion } from "framer-motion";
import { PROCESS } from "../lib/data";

export const Process = () => {
    const prefix = "//";
    return (
        <section id="process" data-testid="process-section" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                            {prefix} The Process
                        </div>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
                            Simple. Transparent. <span className="text-gradient-cyan">No surprises.</span>
                        </h2>
                        <p className="mt-6 text-lg text-slate-400 leading-relaxed">
                            You're busy running your business. My job is to make hiring a developer
                            feel less risky than not hiring one. Here's exactly how it goes.
                        </p>
                    </div>

                    <div className="lg:col-span-7 space-y-4">
                        {PROCESS.map((p, i) => (
                            <motion.div
                                key={p.step}
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-50px" }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                                data-testid={`process-step-${p.step}`}
                                className="group flex gap-6 p-7 rounded-2xl border border-white/5 hover:border-cyan-400/30 bg-[#0a1024] transition-all"
                            >
                                <div className="text-5xl md:text-6xl font-black text-gradient-cyan leading-none tracking-tighter min-w-[80px]">
                                    {p.step}
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-2xl font-semibold mb-2">{p.title}</h3>
                                    <p className="text-slate-400 leading-relaxed">{p.desc}</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
